export enum OrderPaymentSources {
    History = 'history',
    CreateOrder = 'createOrder',
}
